/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPermission } from './BusinessPermission';
import {
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
    BusinessPermissionToJSONTyped,
} from './BusinessPermission';

/**
 * 
 * @export
 * @interface BusinessAddUserBody
 */
export interface BusinessAddUserBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessAddUserBody
     */
    email: string;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof BusinessAddUserBody
     */
    permissions: Array<BusinessPermission>;
}

/**
 * Check if a given object implements the BusinessAddUserBody interface.
 */
export function instanceOfBusinessAddUserBody(value: object): value is BusinessAddUserBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function BusinessAddUserBodyFromJSON(json: any): BusinessAddUserBody {
    return BusinessAddUserBodyFromJSONTyped(json, false);
}

export function BusinessAddUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessAddUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'permissions': ((json['permissions'] as Array<any>).map(BusinessPermissionFromJSON)),
    };
}

export function BusinessAddUserBodyToJSON(json: any): BusinessAddUserBody {
    return BusinessAddUserBodyToJSONTyped(json, false);
}

export function BusinessAddUserBodyToJSONTyped(value?: BusinessAddUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'permissions': ((value['permissions'] as Array<any>).map(BusinessPermissionToJSON)),
    };
}

